export default async (context) => {
    if (!process.client) {
        return;
    }
    context.$analytics.trackPageView({
        path: context.route.fullPath,
    });
};
